import { render, staticRenderFns } from "./DocumentManagement.vue?vue&type=template&id=32b6b7af&scoped=true"
import script from "./DocumentManagement.vue?vue&type=script&lang=js"
export * from "./DocumentManagement.vue?vue&type=script&lang=js"
import style0 from "./DocumentManagement.vue?vue&type=style&index=0&id=32b6b7af&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b6b7af",
  null
  
)

export default component.exports